angular.module('autoremind.dashboard.services', [])
    .factory('dashboardService', ['$enhancedHttp', '$timeout', '$rootScope', '$filter', 'PLUGINS', 'accountService', function ($enhancedHttp, $timeout, $rootScope, $filter, plugins, accountService) {
        var dashboardService = {
            widgets: [],
            loadingIndicator: {
                refCount: 0,
                state: true
            },
            loadWidgets: function () {
                var self = this;
                if (self.widgets.length > 0) {
                    return;
                }
                console.log('loadWidgets');
                $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: '/servlets/accounts/dashboard/',
                    //		url: '/mock/widgets/widgets',
                    disableErrorDialog: true
                }, self.loadingIndicator).then(function (data) {
                    if (data.hasOwnProperty('widgets')) {
                        self.filterWidgetsByUserPermissions(data.widgets);
                    }
                }, function (err) {
                });
            },
            filterWidgetsByUserPermissions: function (widgets) {
                var self = this;
                self.widgets.length = 0;
                self.widgets = [];
                console.log('widgets', widgets);
                if (!widgets || widgets.length < 1) {
                    return;
                }
                widgets.forEach(function (item) {
                    var access = false;
                    if (item.permissions !== undefined && item.permissions.length > 0) {
                        for (var j = 0; j < item.permissions.length; j++) {
                            var permission = item.permissions[j];
                            if (accountService.hasUserPermission(item.permissions[j])) {
                                access = true;
                                continue;
                            }
                        }
                    }
                    else {
                        access = true;
                    }
                    if (!access) {
                        return;
                    }
                    if (!plugins.widgetsConfig.hasOwnProperty(item.widgetType)) {
                        return;
                    }
                    item.class = plugins.widgetsConfig[item.widgetType].class;
                    item.directive = plugins.widgetsConfig[item.widgetType].directive;
                    item.headerIcon = plugins.widgetsConfig[item.widgetType].headerIcon ? plugins.widgetsConfig[item.widgetType].headerIcon : plugins.widgetsConfigDefault.headerIcon;
                    self.widgets.push(item);
                });
            },
            saveWidgetsState: function () {
                var data = this.widgets;
                $enhancedHttp({
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    url: '/servlets/accounts/dashboard/',
                    data: data,
                    disableErrorDialog: true
                }, this.loadingIndicator).then(function (data) {
                    console.log('success');
                }, function (err) {
                    console.log('error');
                });
            },
            updateWidgetData: function (widgetName) {
                return $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: '/servlets/accounts/dashboard/' + widgetName + '/',
                    disableErrorDialog: true
                });
            },
            clearWidgets: function () {
                this.widgets = [];
            }
        };
        $rootScope.$on('event:auth-logout', function () {
            dashboardService.clearWidgets();
        });
        return dashboardService;
    }]);
//# sourceMappingURL=dashboard.services.js.map